import { Controller } from "@hotwired/stimulus"

// Live "N / max" character count for a length-capped text field (e.g. the Core Logic instructions). Counts
// code points like the server's length validation does; once over the cap it turns red and says by how much
// (an over-long draft fails autosave until it's shortened).
// The markdown editor re-dispatches `input` on its textarea, so `input->character-count#update` covers it.
export default class extends Controller {
  static targets = ["field", "output"]
  static values = { max: Number }

  connect() {
    this.update()
  }

  update() {
    const length = [...this.fieldTarget.value].length
    const over = length > this.maxValue

    const count = `${length.toLocaleString()} / ${this.maxValue.toLocaleString()}`
    this.outputTarget.textContent =
      over ? `${count} — ${(length - this.maxValue).toLocaleString()} over the limit, shorten to save` : count
    this.outputTarget.classList.toggle("text-red-600", over)
    this.outputTarget.classList.toggle("font-medium", over)
    this.outputTarget.classList.toggle("text-gray-500", !over)
  }
}
